import script from "./display-html.vue?vue&type=script&setup=true&lang=ts"
export * from "./display-html.vue?vue&type=script&setup=true&lang=ts"

import "./display-html.vue?vue&type=style&index=0&id=301467a5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301467a5"]])

export default __exports__